// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const BASKET_REQUEST = 'BASKET_REQUEST';

const BASKET_REMOVE_ITEM = 'BASKET_REMOVE_ITEM';

const BASKET_SEARCH_REQUEST = 'BASKET_SEARCH_REQUEST';
const BASKET_SEARCH_REQUEST_SUCCESS = 'BASKET_SEARCH_REQUEST_SUCCESS';
const BASKET_SEARCH_REQUEST_FAILED = 'BASKET_SEARCH_REQUEST_FAILED';
const CLEAN_BASKET = 'CLEAN_BASKET';
const BASKET_RESET = 'BASKET_RESET';

const BASKET_REQUEST_SUCCESS = 'BASKET_REQUEST_SUCCESS';
const BASKET_REQUEST_FAILED = 'BASKET_REQUEST_FAILED';

const BASKET_SEARCH_FIELD_CHANGE = 'BASKET_SEARCH_FIELD_CHANGE';
const BASKET_SEARCH_ERROR_CHANGE = 'BASKET_SEARCH_ERROR_CHANGE';

const SET_BASKET_TOTAL = 'SET_BASKET_TOTAL';

const LOADING_START = 'LOADING_START';
const LOADING_STOP = 'LOADING_STOP';

const SET_VOUCHER_CODE = 'SET_VOUCHER_CODE';
const SET_DELETE_ID = 'SET_DELETE_ID';

const GET_CART_ID = 'GET_CART_ID';

const GET_IS_ELIGIBLE_FOR_HOME_PICKUP = 'GET_IS_ELIGIBLE_FOR_HOME_PICKUP';
const SET_IS_ELIGIBLE_FOR_HOME_PICKUP = 'SET_IS_ELIGIBLE_FOR_HOME_PICKUP';

const GET_BASKET_NOTIFY_ERROR = 'GET_BASKET_NOTIFY_ERROR';
const SET_BASKET_NOTIFY_ERROR = 'BASKET_NOTIFY_ERROR';

const SET_DISABLE_GET_PRICE_BUTTON = 'SET_DISABLE_GET_PRICE_BUTTON';

export {
  BASKET_REQUEST,

  BASKET_REMOVE_ITEM,

  BASKET_SEARCH_REQUEST,
  BASKET_SEARCH_REQUEST_SUCCESS,
  BASKET_SEARCH_REQUEST_FAILED,
  CLEAN_BASKET,
  BASKET_RESET,

  BASKET_REQUEST_SUCCESS,
  BASKET_REQUEST_FAILED,

  BASKET_SEARCH_FIELD_CHANGE,
  BASKET_SEARCH_ERROR_CHANGE,

  SET_BASKET_TOTAL,

  LOADING_START,
  LOADING_STOP,

  SET_VOUCHER_CODE,
  SET_DELETE_ID,

  GET_CART_ID,

  GET_IS_ELIGIBLE_FOR_HOME_PICKUP,
  SET_IS_ELIGIBLE_FOR_HOME_PICKUP,

  GET_BASKET_NOTIFY_ERROR,
  SET_BASKET_NOTIFY_ERROR,

  SET_DISABLE_GET_PRICE_BUTTON
};
export const SET_BOOKSHOP_BASKET = 'SET_BOOKSHOP_BASKET';
